import DynamicForm from '@components/shared-ui-components/DynamicForm'
import { Paper } from '@mui/material'

function DataLabellingSelectionPage() {

  const handleFieldChange = (fieldName: string, fieldValue: any) => {
    // if (fieldName === 'default_settings') {
    //   if (fieldValue !== false) setDialogOpenStatus(true)
    // }
  }

  return (

    <Paper
      elevation={3} // Add shadow effect
      sx={{
        padding: '20px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '0px'
      }}
    >
      <h4 style={{}}>Please Fill Up The Data Labelling Form</h4>
      <DynamicForm page={'dataLabellingSelection'} handleFieldChange={handleFieldChange} />
    </Paper>
  )
}

export default DataLabellingSelectionPage